/* ================================================================
   MO — PAGE PANIER : CODE PROMO (01/10)

   Va avec sections/mo-panier-articles.liquid et mo-panier-resume.liquid.
   Les quantités et le bouton Retirer restent gérés par assets/cart.js
   (Dawn) ; ce fichier ne s'occupe que du code promo :

   - le client tape un code et appuie sur Appliquer : le code est posé
     sur le panier (/cart/update.js, paramètre « discount »). Shopify
     répond avec le panier à jour ET les deux sections du panier déjà
     redessinées : on les remet en place, la remise apparaît dans le
     total. Le code suit ensuite au paiement.
   - un seul code à la fois : un nouveau code remplace l'ancien.
   - si Shopify refuse le code (inconnu, ou conditions pas remplies),
     on remet les codes d'avant et on dit pourquoi.
   - « × » sur un code : on le retire.
   - « Le taper » dans la jauge : amène au champ du code.

   Rien ne s'applique tout seul : seul le client pose un code.
   ================================================================ */
(function () {
  'use strict';

  if (window.__moPanier) return;
  window.__moPanier = true;

  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var occupe = false;

  function $(s, r) { return (r || document).querySelector(s); }

  function euros(centimes) {
    return (centimes / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function codesActuels() {
    var el = $('[data-mop-codes]');
    if (!el) return [];
    return el.getAttribute('data-mop-codes').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
  }

  function remiseActuelle() {
    var el = $('[data-mop-remise]');
    return el ? parseInt(el.getAttribute('data-mop-remise'), 10) || 0 : 0;
  }

  function nbMaillots() {
    var el = $('[data-mop-maillots]');
    return el ? parseInt(el.getAttribute('data-mop-maillots'), 10) || 0 : 0;
  }

  function sectionsDuPanier() {
    var ids = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    ids.push('cart-icon-bubble');
    return ids;
  }

  function envoyer(codes) {
    return fetch(RACINE + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: sectionsDuPanier(),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* remet en place les sections redessinées par Shopify (comme cart.js) */
  function peindre(panier) {
    var s = panier.sections || {};
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var hote = document.getElementById(id);
      if (!hote || !s[hote.dataset.id]) return;
      var doc = new DOMParser().parseFromString(s[hote.dataset.id], 'text/html');
      var src = doc.querySelector('#' + id + ' .js-contents') || doc.querySelector('.js-contents');
      var dst = hote.querySelector('.js-contents');
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
    var bulle = document.getElementById('cart-icon-bubble');
    if (bulle && s['cart-icon-bubble']) {
      var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
      var src = d.querySelector('.shopify-section');
      bulle.innerHTML = src ? src.innerHTML : d.body.innerHTML;
    }
  }

  /* le code est-il accepté par le panier ? */
  function accepte(panier, code) {
    if (Array.isArray(panier.discount_codes)) {
      for (var i = 0; i < panier.discount_codes.length; i++) {
        var d = panier.discount_codes[i];
        if (String(d.code || '').toUpperCase() === code) return d.applicable !== false;
      }
      return false;
    }
    /* repli, si Shopify ne renvoie pas discount_codes : on cherche le code dans les remises */
    var vus = [];
    (panier.cart_level_discount_applications || []).forEach(function (a) { vus.push(String(a.title || '').toUpperCase()); });
    (panier.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        vus.push(String((al.discount_application || {}).title || '').toUpperCase());
      });
    });
    return vus.indexOf(code) > -1;
  }

  function message(texte, genre) {
    var m = $('[data-mop-msg]');
    var champ = $('#MopCode');
    if (m) {
      m.textContent = texte;
      m.className = 'mop-code__msg' + (genre ? ' mop-code__msg--' + genre : '');
    }
    if (champ) {
      champ.classList.toggle('mop-faux', genre === 'err');
      champ.setAttribute('aria-invalid', genre === 'err' ? 'true' : 'false');
    }
  }

  function attente(oui) {
    var f = document.getElementById('main-cart-footer');
    if (f) f.classList.toggle('mop-charge', oui);
    var b = $('[data-mop-code] button[type="submit"]');
    if (b) b.disabled = oui;
  }

  function raisonRefus(code) {
    if (code === '3POUR2') {
      var n = nbMaillots();
      if (n < 3) {
        var manque = 3 - n;
        return '3POUR2 marche à partir de 3 maillots. Ajoutes-en ' + manque + ' et retape-le.';
      }
    }
    return code + ' ne marche pas avec ce panier. Vérifie l’orthographe, ou les conditions du code.';
  }

  function appliquer(brut) {
    if (occupe) return;
    var code = String(brut || '').trim().toUpperCase().replace(/\s+/g, '');
    if (!code) { message('Tape ton code avant d’appuyer sur Appliquer.', 'err'); return; }
    var avant = codesActuels();
    if (avant.indexOf(code) > -1) { message(code + ' est déjà appliqué.', 'ok'); return; }
    var remiseAvant = remiseActuelle();

    occupe = true;
    attente(true);
    envoyer([code])
      .then(function (panier) {
        if (accepte(panier, code)) {
          peindre(panier);
          var gain = (panier.total_discount || 0) - remiseAvant;
          message(
            'Code ' + code + ' appliqué' + (gain > 0 ? ' : −' + euros(gain) : '') + '.' +
            (avant.length ? ' Il remplace ' + avant.join(', ') + '.' : ''),
            'ok'
          );
          return;
        }
        /* refusé : on remet le panier comme avant */
        return envoyer(avant).then(function (p2) {
          peindre(p2);
          var champ = $('#MopCode');
          if (champ) champ.value = code;
          message(raisonRefus(code), 'err');
        });
      })
      .catch(function () {
        message('Petit souci de connexion. Réessaie dans un instant.', 'err');
      })
      .then(function () {
        occupe = false;
        attente(false);
      });
  }

  function retirer(code) {
    if (occupe) return;
    var reste = codesActuels().filter(function (c) { return c !== code; });
    occupe = true;
    attente(true);
    envoyer(reste)
      .then(function (panier) {
        peindre(panier);
        message('Code ' + code + ' retiré.', 'ok');
      })
      .catch(function () {
        message('Petit souci de connexion. Réessaie dans un instant.', 'err');
      })
      .then(function () {
        occupe = false;
        attente(false);
      });
  }

  /* Si un autre morceau du site change le panier pendant qu'on est sur
     cette page (ajout rapide, appli…), Dawn redessinerait le panier avec
     son ancienne section (main-cart-items, désactivée) : on le redessine
     plutôt avec les deux sections MO. */
  function rafraichir() {
    return fetch(RACINE + 'cart?sections=' + sectionsDuPanier().join(','), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (s) {
        peindre({ sections: s });
        var vide = !document.querySelector('#main-cart-items .cart-item');
        var a = document.querySelector('cart-items.mop');
        var f = document.getElementById('main-cart-footer');
        if (a) a.classList.toggle('is-empty', vide);
        if (f) f.classList.toggle('is-empty', vide);
      })
      .catch(function () {});
  }
  if (window.customElements) {
    window.customElements.whenDefined('cart-items').then(function () {
      var el = document.querySelector('cart-items.mop');
      if (el) el.onCartUpdate = rafraichir;
    });
  }

  /* délégation : les sections sont redessinées souvent, on écoute le document */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-mop-code]');
    if (!f) return;
    e.preventDefault();
    var champ = f.querySelector('input[name="mop_code"]');
    appliquer(champ ? champ.value : '');
  });

  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('[data-mop-retirer]');
    if (r) { e.preventDefault(); retirer(String(r.getAttribute('data-mop-retirer')).toUpperCase()); return; }

    var v = e.target.closest && e.target.closest('[data-mop-viser]');
    if (v) {
      e.preventDefault();
      var champ = $('#MopCode');
      if (champ) {
        champ.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { champ.focus(); }, 350);
      }
    }
  });
})();
